import FTLStopHelpers from '@/utilities/FTLStopHelpers';

export const isSkippedStop = (s) => {
    return s.type === 'LUNCH' || (s.overnight && FTLStopHelpers.isWarehousePickup(s));
};
